import React, { useContext, useEffect, useState } from 'react'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import ProductContainer from './ProductContainer'
import './Auctiontracker.css'
import Layout from '../Layout'
import ListCard from './ListCard'
import LiveAuctionTrackerCard from './LiveAuctionTrackerCard'
import PriceTracker from './PriceTracker'
import { useParams } from 'react-router-dom'
import ProductContext from '../../../Product/context/product/productContext'
import { useHistory } from 'react-router-dom'

const AuctionTracker = (props) => {
    const [value, setValue] = React.useState(0)
    const [selectedProduct, setSelectedProduct] = React.useState({})
    const [toggleLiveAuction, setToggleLiveAuction] = React.useState(true)
    const [toggleDetailsAuction, setToggleDetailsAuction] = React.useState(true)
    const productContext = useContext(ProductContext)
    const { getAuctionTracker, auction_tracker } = productContext
    const { pid } = props.match.params
    let history = useHistory()

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        console.log('auction_tracker', auction_tracker)
        if (auction_tracker && auction_tracker.success == 'yes') {
            setSelectedProduct({
                ...auction_tracker.item_details,
            })
        }
    }, [auction_tracker])

    useEffect(() => {
        getAuctionTracker({
            asinno: pid,
            site_id: global?.storeDetails?.site_id,
        })
    }, [pid])

    const handleToggleLiveAuction = () => {
        setToggleLiveAuction(!toggleLiveAuction)
    }

    const handleToggleDetailsAuction = () => {
        setToggleDetailsAuction(!toggleDetailsAuction)
    }

    return (
        <>
            <SEOTAG page="Auction Tracker" />
            <Layout props={props}>
                <div className="customContainer mx-auto px-4 mt-4">
                    <ProductContainer pid={pid} data={selectedProduct} />
                    <div className="listFlexContainer">
                        <ListCard data={selectedProduct} />
                    </div>
                    <div className="LiveAccordionTracker">
                        <div
                            className="LiveAccordionTrackerHeader"
                            onClick={() => handleToggleLiveAuction()}
                        >
                            <h3 className="h3">Live Auctions</h3>
                            <span className="material-icons-outlined">
                                {toggleLiveAuction ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                            </span>
                        </div>
                        {toggleLiveAuction && (
                            <div className="LiveAccordionTrackerBody">
                                <LiveAuctionTrackerCard data={selectedProduct?.live_auctions} />
                            </div>
                        )}
                    </div>
                    <div className="pricingOuterContainer">
                        <PriceTracker data={selectedProduct} />
                    </div>
                    <div className="proDescInnerBox">
                        <div className="proDesccontainer">
                            <div
                                className="DetailsAccordionTrackerHeader"
                                onClick={() => handleToggleDetailsAuction()}
                            >
                                <h3 className="h3">Product Description & Details</h3>
                                <span className="material-icons-outlined">
                                    {toggleDetailsAuction
                                        ? 'keyboard_arrow_up'
                                        : 'keyboard_arrow_down'}
                                </span>
                            </div>
                            {toggleDetailsAuction && (
                                <div className="proAccordionTrackerBody">
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: selectedProduct?.product?.description,
                                        }}
                                    ></p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AuctionTracker
